module.exports = __webpack_public_path__ + "static/img/scco-op.672bfb5b.png";